<template>
  <li
    v-if="canViewHorizontalNavMenuHeaderGroup(item)"
    class="dropdown nav-item"
    :class="{
      'sidebar-group-active active open': isActive,
      'show': isOpen,
    }"
    @mouseenter="() => updateGroupOpen(true)"
    @mouseleave="onMouseLeave"
  >
    <b-link class="nav-link dropdown-toggle d-flex align-items-center" style="padding: 20px 0;">
      <feather-icon
        size="14"
        :icon="item.icon"
      />
      <span class="text-capitalize">{{ $tc(item.header, 2) }}</span>
    </b-link>
    <ul class="dropdown-menu">
      <component
        :is="resolveHorizontalNavMenuItemComponent(child)"
        v-for="child in item.children"
        :key="child.title"
        :item="child"
      />
    </ul>
  </li>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { resolveHorizontalNavMenuItemComponent } from '@core/layouts/utils'
import { useUtils as useAclUtils } from '@core/libs/acl'
import useHorizontalNavMenuHeaderGroup from './useHorizontalNavMenuHeaderGroup'
import mixinHorizontalNavMenuHeaderGroup from './mixinHorizontalNavMenuHeaderGroup'

import HorizontalNavMenuGroup from '../horizontal-nav-menu-group/HorizontalNavMenuGroup.vue'
import HorizontalNavMenuLink from '../horizontal-nav-menu-link/HorizontalNavMenuLink.vue'

export default {
  components: {
    BLink,
    HorizontalNavMenuGroup,
    HorizontalNavMenuLink,
  },
  mixins: [mixinHorizontalNavMenuHeaderGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const {
      isActive,
      updateIsActive,
      isOpen,
      updateGroupOpen,
    } = useHorizontalNavMenuHeaderGroup(props.item)

    const { canViewHorizontalNavMenuHeaderGroup } = useAclUtils()

    // Only close immediately if mouse stays inside the main menu container; otherwise let container close with delay
    const onMouseLeave = (e) => {
      const container = document.getElementById('main-menu-navigation')
      const next = e && e.relatedTarget
      const isStillInsideContainer = container && next ? container.contains(next) : false

      if (isStillInsideContainer) {
        updateGroupOpen(false)
      }
    }

    return {
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
      resolveHorizontalNavMenuItemComponent,
      onMouseLeave,

      // ACL
      canViewHorizontalNavMenuHeaderGroup,
    }
  },
}
</script>
